<div class="flyout">
  <div
    #dialog
    class="search-flyout flyout-main-container mt-lg-0 pl-0 pr-0"
    tabindex="0"
  >
    <div class="container container-wrapper">
      <div
        [style.position]="flyOutLocation"
        [style.top.px]="flyOutPositionHeight"
        class="flyout-content content content-loggedIn"
      >
        <div class="mt-0 footer-closeBtn-display">
          <button
            (click)="close()"
            class="flyout-close icon-moreoptionsclose float-right d-none d-lg-block mr-2 circle-outline"
            type="button"
          >
            <img
              alt="close"
              class="ng-tns-c0-0"
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            />
            <span class="sr-only">search dialog</span>
          </button>
        </div>
        <div class="search-container">
          <div class="search-form-container">
            <div class="form-row align-items-center search-dialog m-0">
              <div class="col-1 col-sm-1 d-lg-none ml-4 mr-1 p-0">
                <span class="search icon-search-icon m-0"></span>
              </div>
              <div class="col-7 col-lg-12 col-md-8 col-sm-7 p-0">
                <label
                  [ngClass]="{
                    placeholder:
                      !isSearchFocused && searchField?.value?.length < 1,
                    'd-none d-lg-block': searchField?.value?.length > 0
                  }"
                  class="search-label"
                  for="search_input"
                >
                  {{
                    !isSearchFocused && searchField.value.length === 0
                      ? contentSearch
                        ? contentSearch.searchLabel
                        : 'Search
                    for a topic'
                      : contentSearch
                      ? contentSearch.searchFloatingLabel
                      : 'Search for a topic'
                  }}
                </label>
                <div
                  [ngClass]="{ active: isSearchFocused }"
                  class="input-group"
                >
                  <input
                    #searchField
                    (focus)="onSearchFieldFocus()"
                    (focusout)="onSearchFieldFocusout()"
                    (keydown.enter)="onSearchSubmit()"
                    aria-describedby="resultStatus"
                    aria-invalid="false"
                    autocomplete="off"
                    class="form-control mb-2 mb-sm-0 custom-search-color"
                    id="search_input"
                    placeholder
                    type="text"
                  />
                  <span class="input-group-addon p-0">
                    <button
                      (click)="clearSearchField()"
                      [ngClass]="{ 'd-none': searchField?.value?.length < 1 }"
                      class="btn btn-clear custom-search-icon"
                      type="button"
                    >
                      <span class="sr-only">Clear Search</span>
                    </button>
                    <button
                      (click)="onSearchSubmit()"
                      class="btn btn-search icon-search-icon d-none d-lg-block circle-outline"
                      type="button"
                    >
                      <span class="sr-only">Submit Search</span>
                    </button>
                  </span>
                </div>
              </div>
              <div
                (click)="close()"
                class="col-2 col-sm-3 col-md-2 d-lg-none bg-dark cancel-label"
              >
                <span class="d-block text-right text-capitalize">cancel</span>
              </div>
            </div>
          </div>
          <div class="popular-topics">
            <h2 class="title">
              {{
                contentSearch ? contentSearch.popularLabel : 'popular topics'
              }}
            </h2>

            <ul>
              <li
                *ngFor="let topic of contentPopularTopic; index as i"
                [ngClass]="{ 'display-topicLink': i > 2 }"
              >
                <a
                  draggable="false"
                  href="#"
                  (click)="updateAnalytics(topic.populartopicsLink, topic)"
                >
                  {{ topic.populartopicsTitle }}
                </a>
              </li>
            </ul>
          </div>
          <div
            [ngClass]="{
              'd-block':
                searchField?.value?.length > 2 && searchResults.length > 0
            }"
            class="search-results d-none pl-1"
            tabindex="-1"
          >
            <span
              aria-live="assertive"
              class="sr-only"
              id="resultStatus"
              role="status"
            >
              <span *ngIf="searchResults.length > 0" class="sr-only">
                search results for {{ searchField?.value }}
              </span>
              <span *ngIf="searchResults.length > 0" class="sr-only">
                {{ searchResults.length }} results are available
              </span>
            </span>
            <ul>
              <li *ngFor="let result of searchResults">
                <a
                  [attr.href]="'#'"
                  draggable="false"
                  innerHTML="{{ result.title }}"
                  (click)="updateAnalytics(result.url, null)"
                ></a>
              </li>
            </ul>
          </div>
          <div
            *ngIf="
              searchField?.value?.length > 2 &&
              showEmptyMessage &&
              searchResults?.length === 0
            "
            class="seatch-results-empty text-center"
            role="alert"
          >
            <span>
              {{
                contentSearch
                  ? contentSearch.noResultText
                  : 'There are no matches for your search'
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
